import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const shopperAgentRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Concierge" },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { ConciergeIndexPage } = await import(
            "@redotech/redo-merchant-marketing-app/concierge/concierge-index-page"
          );
          return { Component: ConciergeIndexPage };
        },
      },
    ],
  },
];
